import Axios from "axios";
import { ZipCode } from '../models/zipcode';

export class ZipCodeService {
  private _api = Axios.create({
    baseURL: process.env.VUE_APP_ECE_API_URL,
    responseType: 'json',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': 'eaQSPYWOqAbDOpjX3zFC2bDJvh6z7wB3wV888d25'
    }
  });

  async GetActiveZipCodeData(): Promise<ZipCode[]> {
    const response = await this._api.get<ZipCode[]>(`/Zipcodes`)
    const list = response.data.filter( d => d.active === true)
    return list;
  }

  async GetZipCodes(): Promise<string[]> {
    const response = await this._api.get<ZipCode[]>(`/Zipcodes`)
    const list = response.data.filter( d => d.active === true).map( d => d.zipcode)
    return list;
  }
}
